import { map } from "lodash";
import formatFilterDate from "helpers/format-filter-date";

export default function translateReferralSearchParams(params) {
  let {
    assignedToSpecialtyIds,
    assignedToUserId,
    assignedToRoleIds,
    assignedToSubSpecialtyIds,
    taskAssignedToUserId,
    taskAssignedToRoleIds,
    createdByUserId,
    assignedToSpecialistId,
    includeAllSites,
    assignedToClinicIds,
    presentingComplaintCodes,
  } = params;

  const {
    status,
    category,
    startDate,
    endDate,
    unreadAddendum,
    isUrgent,
    applyUrgentReferralFirst,
    sortBy,
    sortOrderDescending,
    onlyShowUnassigned,
    taskStatus,
    term,
    daysSinceLastStatusChange,
    isReferrerUrgent,
    isWardRequest,
    referrerAdvisedPriorityCodeIds,
    onlyUnassignedReferrerAdvisedPriority,
    referringOrgUnitIds,
    referringLocationCodeIds,
    reasonForReferralCodeIds,
    typeOfReferralCodeIds,
  } = params;

  assignedToSpecialtyIds = assignedToSpecialtyIds?.value ?? assignedToSpecialtyIds;
  assignedToUserId = assignedToUserId?.value ?? assignedToUserId;
  assignedToRoleIds = assignedToRoleIds?.value ?? assignedToRoleIds;
  assignedToSubSpecialtyIds = assignedToSubSpecialtyIds?.value ?? assignedToSubSpecialtyIds;
  taskAssignedToUserId = taskAssignedToUserId?.value ?? taskAssignedToUserId;
  taskAssignedToRoleIds = map(taskAssignedToRoleIds, x => x?.value ?? x);

  createdByUserId = createdByUserId?.value ?? createdByUserId;
  assignedToSpecialistId = assignedToSpecialistId?.value ?? assignedToSpecialistId;
  includeAllSites = includeAllSites?.value ?? includeAllSites;
  assignedToClinicIds = map(assignedToClinicIds, x => x?.value ?? x);
  presentingComplaintCodes = map(presentingComplaintCodes, x => x?.value ?? x);

  return ({
    status,
    category,
    startDate: formatFilterDate(startDate),
    endDate: formatFilterDate(endDate),
    applyUrgentReferralFirst,
    sortBy,
    sortOrderDescending,
    unreadAddendum,
    isUrgent,
    isWardRequest,
    onlyShowUnassigned,
    assignedToSpecialtyIds,
    assignedToUserId,
    assignedToRoleIds,
    assignedToClinicIds,
    daysSinceLastStatusChange,
    assignedToSubSpecialtyIds,
    taskStatus,
    taskAssignedToUserId,
    taskAssignedToRoleIds,
    createdByUserId,
    term,
    assignedToSpecialistId,
    isReferrerUrgent,
    referringOrgUnitIds,
    referringLocationCodeIds,
    reasonForReferralCodeIds,
    typeOfReferralCodeIds,
    presentingComplaintCodes,
    referrerAdvisedPriorityCodeIds,
    onlyUnassignedReferrerAdvisedPriority,
    includeAllSites,
  });
}
